import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../../store/index'

// Define a type for the slice state
interface UserState {
  user: any
}

// Define the initial state using that type
const initialState: UserState = {
  user: {},
}

export const userSlice = createSlice({
  name: 'user',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    addUserData: (state,action: PayloadAction<number>) => {
      state.user = action.payload
    },
  },
})

export const { addUserData } = userSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectCount = (state: RootState) => state.user.user

export default userSlice.reducer